export default __webpack_public_path__ + "static/DomaineText-Regular-de67cc222e6639c55ede31bf19dbe9c9.ttf";